import { Controller } from "@hotwired/stimulus"

// Lightweight popover for the dashboard view selector.
// Click the trigger button to toggle a short list of view options.
// Click outside the menu (or pick an option) to close.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.outsideClick = this.outsideClick.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    const hidden = this.menuTarget.classList.toggle("hidden")
    if (hidden) {
      document.removeEventListener("click", this.outsideClick)
    } else {
      document.addEventListener("click", this.outsideClick)
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.outsideClick)
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick)
  }
}
